// Supported locales — must match the directories in public/locales/
export const supportedLocales = ['en', 'he', 'fr', 'es', 'zh']
